import { useAuth } from '../../lib/auth.js';
import { useNav } from '../navigation.js';
import { WorkerWeb } from '../worker-web/WorkerWeb.js';

/**
 * Worker preview (doc 04 §1 account menu).
 *
 * The worker experience now EXISTS on the web (`../worker-web/WorkerWeb`), so
 * this screen renders it rather than apologising for its absence.
 *
 * What "preview" means here, precisely, because the distinction is the whole
 * security story:
 *
 *   * It is the signed-in principal's OWN worker record. Every read goes
 *     through `/directory/workers/me` and worker-scoped endpoints, so the
 *     server decides which record that is. There is no worker parameter on
 *     this screen and no way to type one.
 *   * It is not impersonation, and it grants nothing. An administrator sees
 *     what the worker experience looks like through their own account and
 *     their own permissions; a read they could not make elsewhere still fails
 *     here, because it is the same API and the same session.
 *   * Previewing SOMEBODY ELSE's day would need a backend contract that does
 *     not exist — scoped, audited, and deliberate. Faking it client-side by
 *     passing another worker's id is exactly the bypass this banner promises
 *     is not happening, so it is not offered.
 *
 * The banner and the exit are permanent, not decoration: a preview a person
 * can forget they are in is indistinguishable from the real thing, and on an
 * admin account that confusion is the dangerous kind.
 */
export function WorkerPreview() {
  const { me } = useAuth();
  const navigate = useNav();

  return (
    <div className="rn-col" style={{ maxWidth: 860 }}>
      <section className="ww-banner" role="note" aria-label="Preview mode">
        <div className="ww-banner-text">
          <span className="ww-banner-tag">Preview</span>
          <span>
            This is the worker experience, shown through <strong>your own</strong> account
            {me?.name ? ` (${me.name})` : ''}. It uses only the permissions you already hold, and
            never another person&rsquo;s record.
          </span>
        </div>
        <button type="button" className="rn-btn-quiet" onClick={() => navigate('/me/profile')}>
          Exit preview
        </button>
      </section>

      <WorkerWeb />
    </div>
  );
}
